import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';
import Icon from '../icon/index.js';
import { AnimatedLoadingGlyph } from './AnimatedLoadingGlyph.js';
import { jsx } from 'react/jsx-runtime';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function Loader(props) {
  var delay = props.delay,
    restProps = __rest(props, ["delay"]);
  var _useState = useState(delay === undefined),
    shouldDisplay = _useState[0],
    setShouldDisplay = _useState[1];
  // eslint-disable-next-line consistent-return
  useEffect(function () {
    if (delay !== undefined) {
      var timer = setTimeout(function () {
        setShouldDisplay(true);
      }, delay);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [delay]);
  if (!shouldDisplay) {
    return null;
  }
  return /*#__PURE__*/jsx(Icon, _extends({
    "aria-busy": "true",
    role: "status"
  }, restProps, {
    glyph: AnimatedLoadingGlyph
  }));
}

export { Loader };
